module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/appeal_top_sub_01-9c87fdd11c194dbd0648eae74902eae3.jpg";